import React from "react";
import { Outlet } from "react-router-dom";
import styled from "styled-components/macro";
import { CssBaseline } from "@mui/material";
import PerfectScrollBar from "react-perfect-scrollbar";

import GlobalStyle from "../components/GlobalStyle";

const Root = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  > div {
    width: 50%;
    flex: 1;
  }
`;

const ScrollBar = styled(PerfectScrollBar)`
  height: calc(100% - 10px) !important;
  display: flex;

  > * {
    flex: 1;
  }
`;

export default function AuthLayout() {
  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />

      <ScrollBar>
        <Outlet />
      </ScrollBar>
    </Root>
  );
}
